import React, { useEffect } from 'react';

const ImageViewer = ({ src, onClose }) => {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    if (!src) return null;

    return (
        <div className="image-viewer-overlay active" onClick={onClose}>
            <span className="image-viewer-close" onClick={onClose}>×</span>
            <img className="image-viewer-content" src={src} alt="Full screen view" onClick={(e) => e.stopPropagation()} />
        </div>
    );
};

export default ImageViewer;